import React, { Component } from 'react';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';
import { Layout, Collapse, Icon, Table, Row, Col, Form, DatePicker, Input, Select, Button, Spin, Modal, Tabs, message, Menu } from 'antd';
import axios from 'axios';
import { filter, find, last, uniq, remove, take, slice, sortBy, isNil, cloneDeep, concat, includes } from 'lodash';
import moment from 'moment';

import './ObservationRequest.css';

import IntlMessages from '../../../../util/IntlMessages';
import { toUpperKey } from '../../../../util/helpper';
import ScrollToTop from '../../../../components/ScrollToTop';
import MenuSider from '../../../../components/MenuSider';
import BasicInfo from '../Request/Panel/BasicInfo';
import Checklist from '../Request/Panel/Checklist';
import Category from '../Request/Panel/Category';
import Action from '../Request/Panel/Action';
import Summary from '../Request/Panel/Summary';
import { Odata_Url, Constants } from '../../../../Constants/Constants';
import DateTimeFormat from '../../../../Constants/DateTimeFormat';

const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Content } = Layout;
const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const REQ_STATE = {
    BASIC_INFO: "basic-info",
    CHECKLIST: "checklist",
    CATEGORY_OBSERVATION: "category-observation",
    ACTION: "action",
    SUMMARY: "summary"
}

class ObservationRequest extends Component {

    constructor(prop) {
        super(prop);

        this.state = {
            isLoading: false,
            reqState: REQ_STATE.BASIC_INFO,
            validated: {
                basicInfo: false,
                checkList: false,
                categoryObservation: false,
                action: false,
            },
            areaDatas: [],
            optAreas: [],
            jobTypeDatas: [],
            jobTypeGroupOfFactorys: [],
            jobTypeGroupOfOffices: [],
            categoryDatas: [],
            optCategories: [],
            optCategorySelecteds: [],
            optCategoryUnSafes: [],
            subCategoryDatas: [],
            rootCauseDatas: [],
            userResponseOfCurrentUser: undefined,
            observationTrn: {},
            observationTrnAttachments: [],
            isUnsafe: false,
            isReadonly:false,
        }

        this.refBasicInfo = React.createRef();
        this.refChecklist = React.createRef();
        this.refCategory = React.createRef();
        this.refAction = React.createRef();
        this.refSummary = React.createRef();
    }

    componentDidMount() {
        const observationTrnId = this.props.match.params.id;
        const refTagNo = this.props.match.params.tagno;
        const viewstate = this.props.match.params.viewstate;
        //const urlSearch = new URLSearchParams(this.props.location.search);
        //const observationTrnId = urlSearch.get("id");

        this.setState({ isLoading: true }, () => {
            this.getTokenHeader().then(tokenHeader => {

                const promises = [];

                const $getOptAreas = axios.get(Odata_Url + "OAreaMD?$filter=IsActived eq true&$orderby=Name", tokenHeader).then(optAreaResp => {
                    const areaDatas = optAreaResp.data.value;

                    const rootAreas = filter(areaDatas, { Parentid: null, Ordering: 1 });
                    const optAreas = rootAreas.map((item) => {
                        return {
                            value: item.PKAreaID,
                            label: item.Name,
                            children: []
                        }
                    });
                    optAreas.forEach((area) => {
                        this.setChildOfOptAreas(area, areaDatas, 1);
                    });
                    this.setState({
                        areaDatas: areaDatas,
                        optAreas: optAreas
                    });
                });
                promises.push($getOptAreas);

                const $getJobTypes = axios(Odata_Url + "OJobType?$filter=IsActived eq true and GroupName ne null", tokenHeader).then(jobTypeDataResp => {
                    const jobTypeDatas = jobTypeDataResp.data.value;

                    //#region Set jobTypeGroupOfFactorys
                    const jobTypeDataOfFactorys = filter(jobTypeDatas, { Type: "factory" });
                    const groupNameThOfFactorys = uniq(jobTypeDataOfFactorys.map(x => x.GroupName));
                    const jobTypeGroupOfFactorys = groupNameThOfFactorys.map(x => {
                        return {
                            groupNameEn: "",
                            groupNameTh: x,
                            jobTypes: filter(jobTypeDataOfFactorys, { GroupName: x }),
                        }
                    });
                    jobTypeGroupOfFactorys.forEach(group => {
                        const jobTypeOfThisGroup = find(jobTypeDatas, { GroupName: group.groupNameTh });
                        group.groupNameEn = jobTypeOfThisGroup.GroupName_EN;
                    });

                    //#endregion

                    //#region Set jobTypeGroupOfOffices
                    const jobTypeDataOfOffices = filter(jobTypeDatas, { Type: "office" });
                    const groupNameThOfOffices = uniq(jobTypeDataOfOffices.map(x => x.GroupName));
                    const jobTypeGroupOfOffices = groupNameThOfOffices.map(x => {
                        return {
                            groupNameEn: "",
                            groupNameTh: x,
                            jobTypes: filter(jobTypeDataOfOffices, { GroupName: x }),
                        }
                    });
                    jobTypeGroupOfOffices.forEach(group => {
                        const jobTypeOfThisGroup = find(jobTypeDatas, { GroupName: group.groupNameTh });
                        group.groupNameEn = jobTypeOfThisGroup.GroupName_EN;
                    });
                    //#endregion

                    this.setState({
                        jobTypeDatas: jobTypeDatas,
                        jobTypeGroupOfFactorys: jobTypeGroupOfFactorys,
                        jobTypeGroupOfOffices: jobTypeGroupOfOffices
                    });

                });
                promises.push($getJobTypes);

                const $getCategorys = axios(Odata_Url + "OCategoryMD?$filter=IsActived eq true", tokenHeader).then((categoryDataResp) => {
                    const categoryDatas = categoryDataResp.data.value;

                    this.setState({
                        categoryDatas: categoryDatas,
                    });
                });
                promises.push($getCategorys);

                const $getSubCategory = axios.get(Odata_Url + "OSub_Category?$filter=IsActived eq true", tokenHeader).then(subCateDataResp => {
                    const subCategoryDatas = subCateDataResp.data.value;

                    this.setState({
                        subCategoryDatas: subCategoryDatas,
                    });
                });
                promises.push($getSubCategory);

                const $getRootCause = axios.get(Odata_Url + "ORootcauseMD?$filter=IsActived eq true", tokenHeader).then(rootCauseDataResp => {
                    const rootCauseDatas = rootCauseDataResp.data.value;

                    this.setState({
                        rootCauseDatas: rootCauseDatas,
                    });
                });
                promises.push($getRootCause);

                const $getUserResponseOfCurrentUser = axios.get("api/CTObservationTransactionV2/OptUserResponseByCurrentUser", tokenHeader).then(userResponseOfCurUser => {
                    const userResponseOfCurrentUser = userResponseOfCurUser.data;

                    this.setState({
                        userResponseOfCurrentUser: userResponseOfCurrentUser,
                    });
                });
                promises.push($getUserResponseOfCurrentUser);

                Promise.all(promises).then(() => {
                    if (observationTrnId) {
                        axios("api/CTObservationTransactionV2/GetObservationTransactionById?pkObTranID=" + observationTrnId, tokenHeader).then((observationTrnResp) => {
                            const observationTrn = observationTrnResp.data;

                            this.setState({ observationTrn: observationTrn }, () => {
                            
                                observationTrn.plainSelecteds = [];
                                if (observationTrn.observation_ObserverTypes) {
                                    observationTrn.plainSelecteds = observationTrn.observation_ObserverTypes.map((item) => item.observerType_Name);
                                }
                               
                                
                                //#region bind areaTrees, siteTrees to observationTrn
                                observationTrn.areaTrees = [];
                                observationTrn.siteTrees = [];
                                if (observationTrn.areaID) {
                                    let selectedAreaTreeFromLasts = [];
                                    let areaData = find(this.state.areaDatas, { PKAreaID: observationTrn.areaID });
                                    if (areaData) {
                                        selectedAreaTreeFromLasts.push(areaData.PKAreaID);
                                        let isStop = false;
                                        while (!isStop) {
                                            areaData = find(this.state.areaDatas, { PKAreaID: areaData.Parentid });
                                            if (areaData) {
                                                selectedAreaTreeFromLasts.push(areaData.PKAreaID);
                                            }
                                            else {
                                                isStop = true;
                                            }
                                        }
                                    }

                                    const selectedAreaTrees = selectedAreaTreeFromLasts.reverse();
                                    observationTrn.areaTrees = take(selectedAreaTrees, 3);
                                    observationTrn.siteTrees = slice(selectedAreaTrees, 3);

                                    if (observationTrn.areaTrees.length > 0) {
                                        this.refBasicInfo.setOptSites(last(observationTrn.areaTrees), this.state.areaDatas);
                                    }
                                }
                                //#endregion

                                //#region bind jobTypeData to observationTrn
                                observationTrn.jobTypeData = find(this.state.jobTypeDatas, (jobType) => {
                                    return jobType.PKJobTypeID === observationTrn.jobTypeID;
                                });
                                //#endregion

                                let isUnsafe = false;
                                const optCategoryUnSafes = [];

                                const optCategorieOfTypCats = filter(this.state.categoryDatas, { Type_Category: observationTrn.jobType_Type });

                                axios(Odata_Url + "OJobType_Category?$filter=IsActived eq true and JobTypeId eq " + observationTrn.observation_Job_Details[0].jobTypeID, tokenHeader).then((jobTypeCategoryDataResp) => {
                                    console.debug("jobTypeCategoryDataResp", jobTypeCategoryDataResp.data);

                                    const jobTypeCategoryDatas = jobTypeCategoryDataResp.data.value;
                                    const categoryIds = jobTypeCategoryDatas.map(item => item.CatId);

                                    const optCategories = filter(optCategorieOfTypCats, (cat) => {
                                        return includes(categoryIds, cat.PKCategoryID);
                                    });

                                    const optCategorySelecteds = [];

                                    optCategories.forEach(cat => {
                                        const catTrnSelected = find(this.state.observationTrn.observation_Category_Details, { categoryID: cat.PKCategoryID });
                                        if (catTrnSelected) {
                                            cat.checked = true;
                                            cat.detail = catTrnSelected.detail;
                                            optCategorySelecteds.push(cat);
                                        }
                                        else {
                                            cat.checked = false;
                                        }
                                    });

                                    optCategorySelecteds.forEach(cat => {
                                        cat.subCategories = filter(this.state.subCategoryDatas, { CategoryID: cat.PKCategoryID });

                                        cat.subCategories.forEach(subCate => {
                                            const subCatTrn = find(observationTrn.observation_Sub_Categories, { subCategoryID: subCate.PKSubCategoryID });
                                            if (subCatTrn) {
                                                subCate.unSafe = subCatTrn.unSafe;
                                                if (subCate.unSafe === 1) {
                                                    const foundCate = find(optCategoryUnSafes, { PKCategoryID: cat.PKCategoryID });
                                                    if (!foundCate) {

                                                        if (observationTrn.categoryRootCauseItems) {
                                                            const rootCauseData = find(observationTrn.categoryRootCauseItems, { categoryID: cat.PKCategoryID });
                                                            cat.rootCauseData = rootCauseData;
                                                            cat.rootcauseID = rootCauseData.rootcauseID;
                                                        }
                                                        optCategoryUnSafes.push(cat);
                                                    }
                                                    isUnsafe = true;
                                                }
                                            }
                                        });

                                        cat.optRootCauses = filter(this.state.rootCauseDatas, { CategoryID: cat.PKCategoryID });
                                    });

                                    //#region map observationTrn.attachments to observationTrnAttachments
                                    let observationTrnAttachments = [];
                                    const attachmentFileIds = observationTrn.attachments.map(file => {
                                        return file.guid;
                                    });

                                    const $getFiles = axios.post("api/fileApi/list", attachmentFileIds, tokenHeader).then(filesResp => {
                                        observationTrnAttachments = filesResp.data;
                                        observationTrnAttachments.forEach(file => {
                                            file.uid = file.id;
                                            file.url = "file/dist/" + file.fileNameUnique;
                                        });
                                    });
                                    //#endregion

                                    let minObservationDate = moment().startOf('month');
                                    let maxObservationDate = moment().endOf('month');
                                    if (observationTrn && observationTrn.observation_Date) {
                                        minObservationDate = moment(observationTrn.observation_Date, 'YYYY-MM-DDThh:mm:ss').startOf('month');
                                        maxObservationDate = moment(observationTrn.observation_Date, 'YYYY-MM-DDThh:mm:ss').endOf('month');
                                    }

                                    Promise.all([$getFiles]).then(() => {
                                        this.setState({
                                            observationTrnAttachments: observationTrnAttachments,
                                            optCategories: optCategories,
                                            optCategorySelecteds: optCategorySelecteds,
                                            isUnsafe: isUnsafe,
                                            optCategoryUnSafes: optCategoryUnSafes,
                                            minObservationDate: minObservationDate,
                                            maxObservationDate: maxObservationDate,
                                        });
                                        this.setState({ isLoading: false });
                                    });


                                    let role = JSON.parse(window.localStorage.getItem('RoleID'))
                                    if (viewstate === 'view') {
                                        this.setState({ isReadonly: true });
                                    }
                                    else {
                                        console.debug(this.state);
                                        if (this.state.observationTrn.userCreate === this.state.userResponseOfCurrentUser.userId || role === 5 || role === 4) {
                                            this.setState({ isReadonly: false })
                                        }
                                        else {
                                            this.setState({ isReadonly: true })
                                        }
                                    }
                                });
                            });
                        });
                        console.log(this.state.userResponseOfCurrentUser);
                        
                    }
                    else {
                        if (refTagNo) {
                            axios("api/CTObservationTransactionV2/InitFromProductionTagReportNo?tagNo=" + refTagNo, tokenHeader).then((observationTrnResp) => {
                                const observationTrn = observationTrnResp.data;
                                observationTrn.productionTagReportNo = refTagNo;
                                observationTrn.plainSelecteds = [];
                                observationTrn.categoryRootCauseItems = [];

                                this.setState({ observationTrn: observationTrn }, () => {

                                    //#region bind areaTrees, siteTrees to observationTrn
                                    observationTrn.areaTrees = [];
                                    observationTrn.siteTrees = [];
                                    if (observationTrn.areaID) {
                                        let selectedAreaTreeFromLasts = [];
                                        let areaData = find(this.state.areaDatas, { PKAreaID: observationTrn.areaID });
                                        if (areaData) {
                                            selectedAreaTreeFromLasts.push(areaData.PKAreaID);
                                            let isStop = false;
                                            while (!isStop) {
                                                areaData = find(this.state.areaDatas, { PKAreaID: areaData.Parentid });
                                                if (areaData) {
                                                    selectedAreaTreeFromLasts.push(areaData.PKAreaID);
                                                }
                                                else {
                                                    isStop = true;
                                                }
                                            }
                                        }

                                        const selectedAreaTrees = selectedAreaTreeFromLasts.reverse();
                                        observationTrn.areaTrees = take(selectedAreaTrees, 3);
                                        observationTrn.siteTrees = slice(selectedAreaTrees, 3);

                                        if (observationTrn.areaTrees.length > 0) {
                                            this.refBasicInfo.setOptSites(last(observationTrn.areaTrees), this.state.areaDatas);
                                        }
                                    }
                                    //#endregion

                                    //#region map observationTrn.attachments to observationTrnAttachments
                                    let observationTrnAttachments = [];
                                    const attachmentFileIds = observationTrn.attachments.map(file => {
                                        return file.guid;
                                    });

                                    const $getFiles = axios.post("api/fileApi/list", attachmentFileIds, tokenHeader).then(filesResp => {
                                        observationTrnAttachments = filesResp.data;
                                        observationTrnAttachments.forEach(file => {
                                            file.uid = file.id;
                                            file.url = "file/dist/" + file.fileNameUnique;
                                        });
                                    });
                                    //#endregion

                                    Promise.all([$getFiles]).then(() => {
                                        this.setState({
                                            observationTrnAttachments: observationTrnAttachments,
                                            optCategories: [],
                                            optCategorySelecteds: [],
                                            isUnsafe: false,
                                            optCategoryUnSafes: [],
                                            minObservationDate: moment().startOf('month'),
                                            maxObservationDate: moment().endOf('month'),
                                        });

                                        this.setState({ isLoading: false });
                                    });
                                });
                            });
                        }
                        else {
                            this.setState({
                                isLoading: false,
                                observationTrn: {
                                    observation_Date: moment().format(DateTimeFormat.BackendDate),
                                    observation_Time: moment().format("HH:mm"),
                                    plainSelecteds: [],
                                    areaTrees: [],
                                    siteTrees: [],
                                    categoryRootCauseItems: [],
                                },
                                observationTrnAttachments: [],
                                optCategories: [],
                                optCategorySelecteds: [],
                                isUnsafe: false,
                                optCategoryUnSafes: [],
                                minObservationDate: moment().startOf('month'),
                                maxObservationDate: moment().endOf('month'),
                            });
                        }
                    }
                });
            });
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.location.key !== nextProps.location.key) {
            console.debug("location_change");
        }
    }

    onCategoryChange = (checked, optCategory) => {
        optCategory.checked = checked;

        let optCategorySelecteds = this.state.optCategorySelecteds;
        const optCategoryUnSafes = this.state.optCategoryUnSafes;

        if (checked) {
            optCategorySelecteds.push(optCategory);
        }
        else {
            remove(optCategorySelecteds, (item) => {
                return item.PKCategoryID === optCategory.PKCategoryID;
            });

            remove(optCategoryUnSafes, (item) => {
                return item.PKCategoryID === optCategory.PKCategoryID;
            })
        }

        optCategorySelecteds.forEach(cat => {
            cat.subCategories = filter(this.state.subCategoryDatas, { CategoryID: cat.PKCategoryID });
        });

        let isUnsafe = false;

        optCategorySelecteds.forEach(category => {
            category.subCategories.forEach(subCat => {
                if (subCat.unSafe === 1) {
                    isUnsafe = true;
                }
            });
        });

        optCategorySelecteds = sortBy(optCategorySelecteds, ['SeqNO']);

        this.setState({
            optCategorySelecteds: optCategorySelecteds,
            optCategoryUnSafes: optCategoryUnSafes,
            isUnsafe: isUnsafe
        });
    }

    onClickChangeSubCateResult = (subCate) => {

        if (!isNil(subCate.unSafe)) {
            if (subCate.unSafe === 1) {
                subCate.unSafe = undefined;
            }
            else if (subCate.unSafe === 0) {
                subCate.unSafe = 1;
            }
        }
        else {
            subCate.unSafe = 0;
        }

        this.setState({}, () => {

            const optCategoryUnSafes = this.state.optCategoryUnSafes;

            let isUnsafe = false;

            this.state.optCategorySelecteds.forEach(category => {

                let catIsUnsafe = false;

                category.subCategories.forEach(subCat => {
                    if (subCat.unSafe === 1) {
                        isUnsafe = true;
                        catIsUnsafe = true;
                    }
                });

                if (catIsUnsafe) {
                    const foundItem = find(optCategoryUnSafes, { PKCategoryID: category.PKCategoryID });
                    if (!foundItem) {
                        category.optRootCauses = filter(this.state.rootCauseDatas, { CategoryID: category.PKCategoryID });
                        optCategoryUnSafes.push(category);
                    }
                }
                else {
                    remove(optCategoryUnSafes, item => {
                        return item.PKCategoryID === category.PKCategoryID;
                    })
                }
            });

            this.setState({
                optCategoryUnSafes: optCategoryUnSafes,
                isUnsafe: isUnsafe
            });
        });
    }

    onCategoryDetailChange = (category, value) => {
        category.detail = value;
        this.setState({});
    }

    setChildOfOptAreas = (area, areaDatas, ordering) => {

        if (ordering < 3) {
            const childAreas = filter(areaDatas, { Parentid: area.value });

            area.children = childAreas.map((item) => {
                return {
                    value: item.PKAreaID,
                    label: item.Name,
                    children: []
                }
            });

            area.children.forEach(child => {
                this.setChildOfOptAreas(child, areaDatas, ordering + 1);
            });
        }
    }

    reqStateNext = () => {
        let reqStateNext = REQ_STATE.BASIC_INFO;
        const validated = this.state.validated;

        if (REQ_STATE.BASIC_INFO === this.state.reqState) {

            console.debug("this.refBasicInfo", this.refBasicInfo);

            validated.basicInfo = true;
            if (this.refBasicInfo.validate()) {
                reqStateNext = REQ_STATE.CHECKLIST;
                this._afterLoadRef(this.refChecklist).then(() => {
                    this.refChecklist.setSelectedJobType(this.state.observationTrn.jobType_Type, this.state.observationTrn.jobType_GroupName);
                });
            }
            else {
                reqStateNext = REQ_STATE.BASIC_INFO;
            }
        }
        else if (REQ_STATE.CHECKLIST === this.state.reqState) {
            validated.checkList = true;
            const validateResult = this.refChecklist.validate();
            if (validateResult.isPass) {
                reqStateNext = REQ_STATE.CATEGORY_OBSERVATION;
            }
            else {
                message.error(validateResult.msg);
                reqStateNext = REQ_STATE.CHECKLIST;
            }

        }
        else if (REQ_STATE.CATEGORY_OBSERVATION === this.state.reqState) {
            validated.categoryObservation = true;
            const validateResult = this.refCategory.validate();
            if (validateResult.isPass) {
                reqStateNext = REQ_STATE.ACTION;;
            }
            else {
                message.error(validateResult.msg + " !");
                reqStateNext = REQ_STATE.CATEGORY_OBSERVATION;
            }

        }
        else if (REQ_STATE.ACTION === this.state.reqState) {
            validated.action = true;
            const validateResult = this.refAction.validate();
            if (validateResult.isPass) {
                reqStateNext = REQ_STATE.SUMMARY;
                this._afterLoadRef(this.refSummary).then(() => {
                    this.refSummary.setSummaryAreaDetail(this.state.observationTrn.areaTrees, this.state.observationTrn.siteTrees);
                    this.refSummary.setDefaultActivePanelKeys();
                });

                console.debug("ObservationRequest toSummary", {
                    observationTrn: this.state.observationTrn,
                    observationTrnAttachments: this.state.observationTrnAttachments,
                    isUnsafe: this.state.isUnsafe,
                    optCategorySelecteds: this.state.optCategorySelecteds,
                    optCategoryUnSafes: this.state.optCategoryUnSafes,
                });
            }
            else {
                message.error(validateResult.msg + " !");
                reqStateNext = REQ_STATE.ACTION;
            }
        }

        this.setState({
            validated: validated,
            reqState: reqStateNext,
        });
    }

    reqStateBack = () => {
        let reqStateTo = REQ_STATE.BASIC_INFO;

        if (REQ_STATE.CHECKLIST === this.state.reqState) {
            reqStateTo = REQ_STATE.BASIC_INFO;
        }
        else if (REQ_STATE.CATEGORY_OBSERVATION === this.state.reqState) {
            reqStateTo = REQ_STATE.CHECKLIST;
        }
        else if (REQ_STATE.ACTION === this.state.reqState) {
            reqStateTo = REQ_STATE.CATEGORY_OBSERVATION;
        }
        else if (REQ_STATE.SUMMARY === this.state.reqState) {
            reqStateTo = REQ_STATE.ACTION;
        }

        this.setState({
            reqState: reqStateTo,
        });
    }

    onClickSubmitReq = () => {

        const $setIsLoading = this.setIsLoading(true);
        const $getTokenHeader = this.getTokenHeader();

        Promise.all([$setIsLoading, $getTokenHeader]).then(([_, tokenHeader]) => {

            console.debug("ObservationRequest.submit", {
                observationTrn: this.state.observationTrn,
                observationTrnAttachments: this.state.observationTrnAttachments,
                isUnsafe: this.state.isUnsafe,
                optCategorySelecteds: this.state.optCategorySelecteds,
                optCategoryUnSafes: this.state.optCategoryUnSafes,
            });

            const payload = { ...this.state.observationTrn };
            payload.areaID = last(this.state.observationTrn.siteTrees);
            payload.userResponsibleId = payload.userResponsible;
            payload.observationTypeNames = payload.plainSelecteds;
            payload.jobDetailIDs = [payload.jobTypeData.PKJobTypeID];
            payload.categories = this.state.optCategorySelecteds.map(cat => {
                return {
                    categoryID: cat.PKCategoryID,
                    detail: cat.detail,
                    root_cause: cat.rootCauseData ? cat.rootCauseData.rootcauseTH : undefined,
                    subCategorys: cat.subCategories.map(subCat => {
                        return {
                            subCategoryID: subCat.PKSubCategoryID,
                            unsafe: subCat.unSafe,
                        };
                    }),
                };
            });

            if (payload.nearmiss === undefined || payload.nearmiss === null) {
                payload.nearmiss = false;
            }

            const alreadyUploadAttachments = filter(this.state.observationTrnAttachments, (att) => {
                return att.fileNameUnique !== undefined && att.fileNameUnique !== null;
            });
            const alreadyUplaodAttachmentGuids = alreadyUploadAttachments.map(x => x.id);

            const $uploadFile = new Promise((res, reject) => {
                if (this.state.observationTrnAttachments && this.state.observationTrnAttachments.length > 0) {
                    const formData = new FormData();

                    const newUploadAttachments = filter(this.state.observationTrnAttachments, (att) => {
                        return isNil(att.fileNameUnique);
                    });

                    newUploadAttachments.forEach(attachment => {
                        formData.append(attachment.name, attachment.originFileObj);
                    });

                    const uploadConfig = cloneDeep(tokenHeader);
                    uploadConfig.headers["Content-Type"] = "multipart/form-data";
                    axios.post("api/FileApi/multiple", formData, uploadConfig).then(base64FileReps => {
                        console.debug("ObservationRequest.submit.sendFile", base64FileReps.data);
                        res(base64FileReps.data);
                    }).catch((reason) => {
                        reject(reason);
                    });
                }
                else {
                    res([]);
                }
            });

            $uploadFile.then(newAttachmentReps => {
                const newAttachmentGuids = newAttachmentReps.map(a => a.id);
                payload.attachmentGuids = concat(alreadyUplaodAttachmentGuids, newAttachmentGuids);

                //api/ObservationTransactionV2/Update?id=0
                if (payload.pkObTranID && payload.pkObTranID !== 0) {
                    axios.post("api/CTObservationTransactionV2/Update?id=" + payload.pkObTranID, payload, tokenHeader).then(submitResp => {
                        this.setIsLoading(false);
                        Modal.success({
                            content: (<>{this.props.intl.formatMessage({ id: 'ObservationRequest.submit.result.success' })}</>),
                            onOk: () => {
                                this.props.history.push('/');
                            }
                        });
                        //this.props.history.push('/')
                    }).catch(reason => {
                        console.error("reason", reason);
                        this.setIsLoading(false);
                        Modal.error({
                            title: 'Error',
                            content: "Sorry, something went wrong.",
                        })
                    });
                }
                else {
                    axios.post("api/CTObservationTransactionV2/Create", payload, tokenHeader).then(submitResp => {
                        this.setIsLoading(false);
                        Modal.success({
                            content: (<>{this.props.intl.formatMessage({ id: 'ObservationRequest.submit.result.success' })}</>),
                            onOk: () => {
                                this.props.history.push('/');
                            }
                        });
                        //this.props.history.push('/')
                    }).catch(reason => {
                        console.error("reason", reason);
                        this.setIsLoading(false);
                        Modal.error({
                            title: 'Error',
                            content: "Sorry, something went wrong.",
                        })
                    });
                }

            }).catch(reason => {
                console.error("reason", reason);
                this.setIsLoading(false);
                Modal.error({
                    title: 'Error',
                    content: "Sorry, something went wrong.",
                })
            });
        });
    }

    setOptCategories = (optCategories) => {
        this.setState({ optCategories: optCategories });
    }

    setOptCategorySelecteds = (optCategorySelecteds) => {
        this.setState({ optCategorySelecteds: optCategorySelecteds });
    }

    setOptCategoryUnSafes = (optCategoryUnSafes) => {
        this.setState({ optCategoryUnSafes: optCategoryUnSafes });
    }

    setObservationTrnField = (value = undefined, fieldName = "") => {
        const observationTrn = this.state.observationTrn;
        observationTrn[fieldName] = value;

        this.setState({});
    }

    setObservationTrnFields = (dataFields = []) => {
        const observationTrn = this.state.observationTrn;

        dataFields.forEach(dataField => {
            observationTrn[dataField.fieldName] = dataField.value;
        });

        this.setState({});
    }

    setObservationTrnAttachments = (observationTrnAttachments) => {
        this.setState({
            observationTrnAttachments: observationTrnAttachments
        });
    }

    _afterLoadRef = (ref) => {
        let loop = 0;
        return new Promise((res, reject) => {
            let inval = setInterval(() => {
                loop++;
                if (ref) {
                    clearInterval(inval);
                    res("loaded");
                }

                if (loop > 60000) {
                    clearInterval(inval);
                    reject("timeout");
                }
            }, 1);
        });
    }

    setIsLoading = (isLoading) => {
        var $setLoading = new Promise((resolve, reject) => {
            this.setState({ isLoading: isLoading }, () => {
                resolve(isLoading);
            });
        });
        return $setLoading;
    }

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    localStorage.setItem("ObsReqRedirectAfterLogin", "ObsReqRedirectAfterLogin");
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {

        console.debug("SOTEditDataItem", {
            "observationTrn": this.state.observationTrn,
            "observationTrnAttachments": this.state.observationTrnAttachments,
            "optCategoryUnSafes": this.state.optCategoryUnSafes
        });

        let reqStateBtnNextSpan = this.state.reqState !== REQ_STATE.BASIC_INFO ? 12 : 24;
        let reqStateBtnBackSpan = 12;//this.state.reqState !== REQ_STATE.SUMMARY ? 12 : 24;

        return (<>
            <ScrollToTop />
            <Spin spinning={this.state.isLoading}>
                <MenuSider title="System Management > SOT Edit Data">
                    <Content style={{ margin: '16px 8px 64px 16px' }}>
                        <Tabs activeKey={this.state.reqState}
                            renderTabBar={(props, defaultTabBar) => {
                                const currentPanel = find(props.panels, { key: props.activeKey });
                                if (currentPanel) {
                                    return <div className="state-tab-header">
                                        <strong>{currentPanel.props.tab}</strong>
                                    </div>;
                                }
                                else {
                                    return <></>
                                }

                            }}
                        >
                            <TabPane tab={<IntlMessages id="basic.topic_step1_basic_info" />} key={REQ_STATE.BASIC_INFO}>
                                <BasicInfo
                                    ref={compoment => (this.refBasicInfo = compoment ? compoment.getWrappedInstance() : undefined)}
                                    validated={this.state.validated.basicInfo}
                                    setObservationTrnField={this.setObservationTrnField}
                                    areaDatas={this.state.areaDatas}
                                    optAreas={this.state.optAreas}
                                    minObservationDate={this.state.minObservationDate}
                                    maxObservationDate={this.state.maxObservationDate}
                                    isReadonly={this.state.isReadonly}
                                    setObservationTrnField={this.setObservationTrnField}
                                    setObservationTrnFields={this.setObservationTrnFields}
                                    observationTrn={this.state.observationTrn}
                                />
                            </TabPane>
                            <TabPane tab={<IntlMessages id="checklist.title" />} key={REQ_STATE.CHECKLIST}>
                                <Checklist
                                    ref={compoment => (this.refChecklist = compoment ? compoment.getWrappedInstance() : undefined)}
                                    setIsLoading={this.setIsLoading}
                                    validated={this.state.validated.checkList}
                                    onCategoryChange={this.onCategoryChange}
                                    setObservationTrnField={this.setObservationTrnField}
                                    setObservationTrnFields={this.setObservationTrnFields}
                                    setObservationTrnAttachments={this.setObservationTrnAttachments}
                                    setOptCategories={this.setOptCategories}
                                    setOptCategorySelecteds={this.setOptCategorySelecteds}
                                    setOptCategoryUnSafes={this.setOptCategoryUnSafes}
                                    jobTypeDatas={this.state.jobTypeDatas}
                                    jobTypeGroupOfFactorys={this.state.jobTypeGroupOfFactorys}
                                    jobTypeGroupOfOffices={this.state.jobTypeGroupOfOffices}
                                    categoryDatas={this.state.categoryDatas}
                                    optCategories={this.state.optCategories}
                                    optCategorySelecteds={this.state.optCategorySelecteds}
                                    isReadonly={this.state.isReadonly}
                                    observationTrn={this.state.observationTrn}
                                    observationTrnAttachments={this.state.observationTrnAttachments}
                                />
                            </TabPane>
                            <TabPane tab={<IntlMessages id="checklist.result.title" />} key={REQ_STATE.CATEGORY_OBSERVATION}>
                                <Category
                                    ref={compoment => (this.refCategory = compoment ? compoment.getWrappedInstance() : undefined)}
                                    setIsLoading={this.setIsLoading}
                                    validated={this.state.validated.categoryObservation}
                                    setObservationTrnField={this.setObservationTrnField}
                                    setObservationTrnFields={this.setObservationTrnFields}
                                    isReadonly={this.state.isReadonly}
                                    onClickChangeSubCateResult={this.onClickChangeSubCateResult}
                                    onCategoryDetailChange={this.onCategoryDetailChange}
                                    optCategorySelecteds={this.state.optCategorySelecteds}
                                    observationTrn={this.state.observationTrn}
                                />
                            </TabPane>
                            <TabPane tab={<IntlMessages id="Action.title" />} key={REQ_STATE.ACTION}>
                                <Action
                                    ref={compoment => (this.refAction = compoment ? compoment.getWrappedInstance() : undefined)}
                                    setIsLoading={this.setIsLoading}
                                    validated={this.state.validated.action}
                                    setOptCategoryUnSafes={this.setOptCategoryUnSafes}
                                    setObservationTrnField={this.setObservationTrnField}
                                    setObservationTrnFields={this.setObservationTrnFields}
                                    observationTrn={this.state.observationTrn}
                                    isUnsafe={this.state.isUnsafe}
                                    isReadonly={this.state.isReadonly}
                                    optCategoryUnSafes={this.state.optCategoryUnSafes}
                                    userResponseOfCurrentUser={this.state.userResponseOfCurrentUser}
                                />
                            </TabPane>
                            <TabPane tab={<IntlMessages id="Summary.title" />} key={REQ_STATE.SUMMARY}>
                                <Summary
                                    ref={compoment => (this.refSummary = compoment ? compoment.getWrappedInstance() : undefined)}
                                    setIsLoading={this.setIsLoading}
                                    areaDatas={this.state.areaDatas}
                                    optCategoryUnSafes={this.state.optCategoryUnSafes}
                                    observationTrn={this.state.observationTrn}
                                    isUnsafe={this.state.isUnsafe}
                                    observationTrnAttachments={this.state.observationTrnAttachments}
                                />
                            </TabPane>
                        </Tabs>
                    </Content>
                    <div className="state-bar">
                        <Row className="state-affix-row">
                            {this.state.reqState !== REQ_STATE.BASIC_INFO ?
                                (<Col xs={reqStateBtnBackSpan} sm={reqStateBtnBackSpan} md={reqStateBtnBackSpan} lg={reqStateBtnBackSpan} xl={reqStateBtnBackSpan} style={{ borderRight: "1px solid rgb(0 133 121)" }}>
                                    <Button type="link" className="state-back-btn"
                                        onClick={this.reqStateBack}
                                    >
                                        <Icon type="step-backward" /><IntlMessages id='Back' />
                                    </Button>
                                </Col>)
                                :
                                (<></>)
                            }
                            {this.state.reqState !== REQ_STATE.SUMMARY ?
                                (<Col xs={reqStateBtnNextSpan} sm={reqStateBtnNextSpan} md={reqStateBtnNextSpan} lg={reqStateBtnNextSpan} xl={reqStateBtnNextSpan}>
                                    <Button type="link" className="state-next-btn"
                                        onClick={this.reqStateNext}
                                    >
                                        <IntlMessages id='Next' /><Icon type="step-forward" />
                                    </Button>
                                </Col>)
                                :
                                (<></>)
                            }
                            {this.state.reqState === REQ_STATE.SUMMARY ?
                                (<Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button type="link" className="state-next-btn" disabled={this.state.isReadonly}
                                        onClick={this.onClickSubmitReq}
                                    >
                                        <Icon type="check" />&nbsp;<IntlMessages id='Submit' />
                                    </Button>
                                </Col>)
                                :
                                (<></>)
                            }
                        </Row>
                    </div>
                </MenuSider>

            </Spin>
        </>);
    }
}

export default injectIntl(ObservationRequest);